import React from 'react'
import Link from 'gatsby-link'
import logo from '../images/logo.svg'
import '../layouts/index.css'

const Footer = ({ siteTitle }) => (
  <div>
    <div className="creditos">
        <div className="contiene_creditos">
            <span>Créditos</span>
            <ul className="que">
                <li>PROYECTO:</li>
                <li>LÍDER DE PROYECTO:</li>
                <li>TEXTOS:</li>
                <li>PRODUCTO DIGITAL:</li>
                <li>DISEÑO:</li>
                <li>DESARROLLO:</li>
                <li>VIDEO:</li>
                <li>FOTOGRAFÍA:</li>
            </ul>
            <ul className="quien">
                <li>Univision Deportes</li>
                <li>Gustavo García</li>
                <li>Adrián Segovia, Andrés Corona Zurita y Gustavo García</li>
                <li>Oscar Rodríguez</li>
                <li>Jorge Lara y Laura Ortiz</li>
                <li>Juan Jorge Hernández y Natalia Herrera</li>
                <li>Diego Pinzón</li>
                <li>Jorge Lara</li>
            </ul>
        </div>           
    </div>
  </div>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer.js